import { render, staticRenderFns } from "./supplierTable.vue?vue&type=template&id=1c62d9be&scoped=true&"
import script from "./supplierTable.vue?vue&type=script&lang=js&"
export * from "./supplierTable.vue?vue&type=script&lang=js&"
import style0 from "./supplierTable.vue?vue&type=style&index=0&id=1c62d9be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c62d9be",
  null
  
)

export default component.exports